import { render } from "./BenefitsSection.vue?vue&type=template&id=0450bcae&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"

import "./BenefitsSection.vue?vue&type=style&index=0&id=0450bcae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0450bcae"]])

export default __exports__